export default "__VITE_ASSET__14nhr_fB__"